export const  EXPORT_TEMPLATE_SAMPLE_FILE_PATH = './assets/export-templates/ALL-ONTOLOGIES.xlsm';
export const  EXPORT_TEMPLATE_SAMPLE_FILE_NAME = 'ALL-ONTOLOGIES.xlsm';